// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as PaymentBody$OrcaPaymentPage from "./PaymentBody.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./PaymentUtils.bs.js";
import * as UtilityHooks$OrcaPaymentPage from "../Hooks/UtilityHooks.bs.js";

function getTransactionDetail(dict) {
  var amountDict = Utils$OrcaPaymentPage.getDictFromDict(dict, "amount");
  var merchantDict = Utils$OrcaPaymentPage.getDictFromDict(dict, "merchant");
  return {
          orderNumber: Utils$OrcaPaymentPage.getString(dict, "order_number", ""),
          merchant: {
            name: Utils$OrcaPaymentPage.getString(merchantDict, "name", ""),
            url: Utils$OrcaPaymentPage.getString(merchantDict, "url", ""),
            countryCode: Utils$OrcaPaymentPage.getString(merchantDict, "country_code", "")
          },
          amount: {
            option: Utils$OrcaPaymentPage.getString(amountDict, "option", ""),
            currency: Utils$OrcaPaymentPage.getString(amountDict, "currency_code", ""),
            total: Utils$OrcaPaymentPage.getString(amountDict, "total", "")
          }
        };
}

function handleSamsungPayClicked(sessionObj, componentName, iframeId, readOnly, isSavedMethodsFlowOpt) {
  var isSavedMethodsFlow = isSavedMethodsFlowOpt !== undefined ? isSavedMethodsFlowOpt : false;
  Utils$OrcaPaymentPage.messageParentWindow(undefined, [
        [
          "fullscreen",
          true
        ],
        [
          "param",
          "paymentloader"
        ],
        [
          "iframeId",
          iframeId
        ],
        [
          "componentName",
          componentName
        ]
      ]);
  if (!readOnly) {
    return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                [
                  "SamsungPayClicked",
                  true
                ],
                [
                  "SPayPaymentDataRequest",
                  getTransactionDetail(sessionObj)
                ],
                [
                  "isSavedMethodsFlow",
                  isSavedMethodsFlow
                ]
              ]);
  }
  
}

function getPaymentMethodData(dict) {
  var threeDSDict = Utils$OrcaPaymentPage.getDictFromDict(dict, "3DS");
  return {
          method: Utils$OrcaPaymentPage.getString(dict, "method", ""),
          recurring_payment: Utils$OrcaPaymentPage.getBool(dict, "recurring_payment", false),
          card_brand: Utils$OrcaPaymentPage.getString(dict, "card_brand", ""),
          card_last4digits: Utils$OrcaPaymentPage.getString(dict, "card_last4digits", ""),
          "3_d_s": {
            type: Utils$OrcaPaymentPage.getString(threeDSDict, "type", ""),
            version: Utils$OrcaPaymentPage.getString(threeDSDict, "version", ""),
            data: Utils$OrcaPaymentPage.getString(threeDSDict, "data", "")
          }
        };
}

function itemToObjMapper(dict) {
  return {
          paymentMethodData: getPaymentMethodData(dict)
        };
}

function getSamsungPayBodyFromResponse(sPayResponse) {
  var dict = Utils$OrcaPaymentPage.getDictFromJson(sPayResponse);
  return {
          paymentMethodData: getPaymentMethodData(dict)
        };
}

function useHandleSamsungPayResponse(intent, isSavedMethodsFlowOpt, isWalletOpt) {
  var isSavedMethodsFlow = isSavedMethodsFlowOpt !== undefined ? isSavedMethodsFlowOpt : false;
  var isWallet = isWalletOpt !== undefined ? isWalletOpt : true;
  var options = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var publishableKey = match.publishableKey;
  var isManualRetryEnabled = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isManualRetryEnabled);
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var isGuestCustomer = UtilityHooks$OrcaPaymentPage.useIsGuestCustomer();
  React.useEffect((function () {
          var handleSamsung = function (ev) {
            var json = Utils$OrcaPaymentPage.safeParse(ev.data);
            var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
            if (Core__Option.isSome(dict["samsungPayResponse"]) && Utils$OrcaPaymentPage.getBool(dict, "isSavedMethodsFlow", false) === isSavedMethodsFlow) {
              var metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "samsungPayResponse");
              var getBody = getSamsungPayBodyFromResponse(metadata);
              var body = PaymentBody$OrcaPaymentPage.samsungPayBody(getBody.paymentMethodData);
              var finalBody = PaymentUtils$OrcaPaymentPage.appendedCustomerAcceptance(isGuestCustomer, paymentMethodListValue.payment_type, body, options.alwaysSendCustomerAcceptance);
              intent(false, finalBody, {
                    return_url: options.wallets.walletReturnUrl,
                    publishableKey: publishableKey
                  }, undefined, undefined, undefined, isManualRetryEnabled, undefined);
            }
            if (Core__Option.isSome(dict["samsungPayError"])) {
              Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                      "fullscreen",
                      false
                    ]]);
              if (isSavedMethodsFlow || !isWallet) {
                return Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
              } else {
                return ;
              }
            }
            
          };
          window.addEventListener("message", handleSamsung);
          return (function () {
                    window.removeEventListener("message", handleSamsung);
                  });
        }), [
        isSavedMethodsFlow,
        isManualRetryEnabled,
        isWallet,
        match.sdkAuthorization
      ]);
}

export {
  getTransactionDetail ,
  handleSamsungPayClicked ,
  getPaymentMethodData ,
  itemToObjMapper ,
  getSamsungPayBodyFromResponse ,
  useHandleSamsungPayResponse ,
}
/* react Not a pure module */
